<ng-container *ifScreenSize="screenType.Desktop">
  <div class="banner" role="banner"></div>
</ng-container>

<ng-container *ngIf="isDragTop">
  <fgb-page-header
    [showQr]="false"
    [pageTitle]="memberName"
    [backButtonLink]="'/'"
    [showFooter]="false"
    [isHomePage]="true"
  ></fgb-page-header>
</ng-container>

<ng-container *ifScreenSize="screenType.Mobile">
  <div class="container px-0">
    <fgb-barcode [isWalletPage]="false" [showBarcode]="true" [isHomePage]="true" [showFooter]="true"></fgb-barcode>
  </div>
</ng-container>

<div #homeContainer class="home-container">
  <ng-container *inProductCode="productCode.SGB">
    <ng-container *ifScreenSize="screenType.Mobile">
      <div class="grab-point"><span class="minimize-icon"> </span></div>
    </ng-container>
  </ng-container>

  <ng-container *notInProductCode="productCode.SGB">
    <div class="container mt-2">
      <fgb-vouchers></fgb-vouchers>
    </div>

    <!--Scorecard Carousel-->
    <fgbcl-scorecard-carousel [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>

    <div class="container rewards-container">
      <!-- Featured Rewards -->
      <fgbcl-featured-rewards [showAllPath]="'rewards/raffles'"></fgbcl-featured-rewards>
    </div>
  </ng-container>

  <!--Scorecard Carousel-->
  <ng-container *inProductCode="productCode.SGB">
    <div class="mt-3">
      <fgbcl-scorecard-carousel [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>
    </div>
  </ng-container>

  <!-- Campaign Offers -->
  <fgbcl-campaigns-offers-list></fgbcl-campaigns-offers-list>

  <div class="container">
    <!-- Announcements -->
    <fgbcl-announcements></fgbcl-announcements>
  </div>
</div>
